import { render } from "./UserPermission.vue?vue&type=template&id=3c02df3c&scoped=true"
import script from "./UserPermission.vue?vue&type=script&lang=js"
export * from "./UserPermission.vue?vue&type=script&lang=js"

import "./UserPermission.vue?vue&type=style&index=0&id=3c02df3c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c02df3c"]])

export default __exports__